import { render } from "./Denomination.vue?vue&type=template&id=3bf24453"
import script from "./Denomination.vue?vue&type=script&lang=js"
export * from "./Denomination.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__